import { SET_CURRENT_BRANCH } from '../actions/constants/ActionTypes';

const initialState = 'branch-1';

/*
 * Reducer to represent the id of the current player in the redux store
 *
 */
const currentBranchId = (state = initialState, action) => {
    switch (action.type) {
        case SET_CURRENT_BRANCH:
            return action.id;
        default:
            return state;
    }
};

export default currentBranchId;